module.exports = __webpack_public_path__ + "img/lhkc.b45151c3.png";